<template>
  <div class="item-container">
    <div
      class="item-icon"
      :class="borderClass"
      @mouseover="showContent"
      v-if="!is_null"
    >
      <img
        :src="icon_src || item_img(item_data['id'])"
        class="iImg"
        v-if="!is_empty"
      />
      <img :src="empty_img" class="iImg" width="34" height="34" v-else />
    </div>
    <div class="item-tips" v-if="!is_null">
      <div class="dBox_tc_equip item-tips-content">
        <div class="item-header">
          <slot name="header">
            <template v-if="!hide_header">
              <h3 :style="nameStyle">{{ item_data['name'] }}</h3>
              <span class="eq_type eq_type">{{ item_data['type_name'] }}</span>
              <span class="eq_ding_opened eq_ding_opened"></span>
            </template>
          </slot>
        </div>

        <slot>
          <div ref="contentElement"></div>
        </slot>
      </div>

      <div
        class="dBox_tc_equip item-tips-rongzhu"
        v-if="rongzhu_content.length > 0"
      >
        <div ref="contentRongzhu"></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import config from '@img/config.json';
const { item_img } = inject('filters');
import px2vw from '@/utils/px2vw';
import { text2html } from '@utils/utils';

const empty_img =
  'https://tx3.res.netease.com/qt/10/0427_yxb/images/items2/empty.jpg';

const props = defineProps({
  item_data: {
    type: Object,
    required: true,
  },
  icon_src: {
    type: String,
    required: false,
  },
  src: {
    type: String,
    required: false,
  },
  size: {
    type: Object,
    required: false,
  },
  hide_header: {
    type: Boolean,
    default: false,
  },
});
const bg = ref();
const contentElement = ref(null);
const contentRongzhu = ref(null);

const computedStyle = computed(() => {
  var size = null;
  if (props.size) {
    size = props.size;
  } else {
    size = config[props.src];
  }
  return {
    backgroundImage: `url(${bg.value})`,
    width: px2vw(size.width) + 'vw',
    height: px2vw(size.height) + 'vw',
  };
});

const nameStyle = computed(() => {
  let name_color = null;
  if (props.item_data?.name_color) {
    name_color = '#' + props.item_data?.name_color;
  }
  return {
    color: name_color,
  };
});

const borderClass = computed(() => {
  if (props.item_data?.star !== undefined) {
    return `elvl_${props.item_data.star}`;
  } else {
    return '';
  }
});

const is_empty = computed(() => {
  return props.item_data?.is_empty;
});

const is_null = computed(() => {
  return props.item_data?.is_empty == undefined;
});

const rongzhu_content = computed(() => {
  return props.item_data?.rongzhu_content || '';
});

/*
rongzhu_content: ""
cenh: 0
content: "#W#G可炼化#W#r#W耐久度：180/181     品相：#cFFFFFF崭新  #r#W物理防御：4#r#W法术防御：1#r#W使用门派：荒火 天机 翎羽 魍魉 龙巫 幽篁 玄溟 #r#W必要等级：1#r#W贵重等级：1#r#W#r#W#r#W#w(7)炼护值　未开启#w(0)"
ding_type: ""
id: 2109
is_empty: false
menh: null
name: "短甲"
name_color: "FFFFFF"
star: 0
type_name: "衣服"
*/

const showContent = () => {
  text2html(props.item_data['content'], contentElement.value, {
    compact: true,
  });
  text2html(rongzhu_content.value, contentRongzhu.value, { compact: true });
};

onMounted(async () => {
  // text2html(props.item_data['content'], contentElement.value, { compact: true });
  // text2html(rongzhu_content.value, contentRongzhu.value, { compact: true });
});
</script>
